// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { RingSizeFragmentDoc } from './ringSize.fragment.generated';
export const RecommendedRingSizeFragmentDoc = gql`
    fragment recommendedRingSize on RecommendedRingSize {
  __typename
  id
  label(region: $region, locale: $locale)
  ringSize {
    ...ringSize
  }
}
    ${RingSizeFragmentDoc}`;